import type { ScriptTabDef } from './ScriptLibrary';

export const OUTREACH_SCRIPT_TABS: ScriptTabDef[] = [
  {
    key: 'ob30',
    label: '30-Day Onboarding',
    alert: {
      type: 'warning',
      message:
        'Timing: 25–35 days post-activation. If hardware was involved, confirm it has been used at least 3 times before calling.',
    },
    blocks: [
      {
        phase: 'OPEN',
        title: 'Opening & warm introduction',
        note: 'Keep the opener under 45 seconds. Do not pitch yet — focus on them first.',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Hi, may I speak with [CONTACT NAME]? … Hi [NAME], this is [YOUR NAME] calling from [COMPANY NAME]. I am on the Customer Success team — I am dedicated to making sure your experience with us starts strong. How are you doing today?',
          },
          {
            speaker: 'Rep (after pleasantries)',
            text:
              'The reason I am calling is that it has been about a month since [BUSINESS NAME] went live with us, and I wanted to personally check in — make sure everything is running smoothly, answer any questions, and make sure you are getting the most out of your setup.',
          },
        ],
      },
      {
        phase: 'DISCOVERY',
        title: 'Check-in questions',
        note: 'Ask 2–3 of these — do not rapid-fire all of them. Let them talk.',
        lines: [
          {
            speaker: 'Processing health',
            text:
              'How has the day-to-day processing been going? Are transactions running smoothly during your busy hours?',
          },
          {
            speaker: 'Hardware & setup',
            text:
              'How are you and your team finding the terminal / POS system? Is everyone comfortable using it, or is there any functionality you feel you are still figuring out?',
          },
          {
            speaker: 'Support experience',
            text:
              'Have you needed to reach out to our support team at all? If so, how was that experience?',
          },
        ],
      },
      {
        phase: 'ENGAGE',
        title: 'Value reinforcement & tips',
        lines: [
          {
            speaker: 'Rep',
            text:
              'One thing I always share at this stage: most merchants do not realize they can [RELEVANT FEATURE TIP]. Have you had a chance to explore that?',
          },
        ],
      },
    ],
  },
  {
    key: 'qcheck',
    label: 'Quarterly Check-in',
    alert: { type: 'info', message: 'Goal: deepen relationship, surface churn risk, and identify expansion opportunities.' },
    blocks: [
      {
        phase: 'OPEN',
        title: 'Relationship framing',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Hi [NAME], this is [YOUR NAME] from [COMPANY]. I am reaching out for our quarterly check-in — not a sales call, just making sure [BUSINESS NAME] is still getting everything you need from us.',
          },
        ],
      },
      {
        phase: 'DISCOVERY',
        title: 'Business pulse',
        lines: [
          {
            speaker: 'Rep',
            text:
              'What has changed in your business since we last spoke — busier seasons, new staff, new locations, anything that affects how you use our system?',
          },
        ],
      },
    ],
  },
  {
    key: 'abr',
    label: 'Annual Business Review',
    blocks: [
      {
        phase: 'OPEN',
        title: 'Set the agenda',
        lines: [
          {
            speaker: 'Rep',
            text:
              'I blocked 30 minutes because I want to walk through a quick annual review — what is working, what could be better, and where we can help you grow next year. Sound good?',
          },
        ],
      },
    ],
  },
  {
    key: 'upsell',
    label: 'Upsell / Cross-sell',
    blocks: [
      {
        phase: 'DISCOVERY',
        title: 'Find the gap',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Based on how you run [BUSINESS NAME] today, what is one thing that still feels manual or clunky — something you wish just worked automatically?',
          },
        ],
      },
    ],
  },
  {
    key: 'nps',
    label: 'NPS Survey Call',
    blocks: [
      {
        phase: 'CLOSE',
        title: 'NPS question',
        lines: [
          {
            speaker: 'Rep',
            text:
              'On a scale of 0–10, how likely are you to recommend us to another merchant? And what is the main reason for that score?',
          },
        ],
      },
    ],
  },
];
